/**
 * EvalPreview — a NO-LOGIN, dev/preview-host-only harness for the dedicated
 * evaluation-workspace SHELL (mockup v3.5). It mounts the real
 * PropertyEvaluationWorkspace full-bleed so the two-row top, the slim footer and
 * the right-pane tabs can be verified on the running dev server WITHOUT auth.
 *
 * The marking surface needs a live property grid (Firestore) which is not
 * available without auth, so the LEFT pane shows its state-aware pointer and the
 * media tabs show their denied/empty states — that is EXPECTED here. This harness
 * exists to verify the workspace CHROME (header / footer / panes / no portal
 * shell), not the live marking. Gated exactly like /preview-intake.
 */
import PropertyEvaluationWorkspace from '../components/evaluate/PropertyEvaluationWorkspace';
import { previewRouteAllowed } from '../lib/previewHost';
import NotFound from './NotFound';

export default function EvalPreview() {
  if (!previewRouteAllowed()) return <NotFound />;
  return (
    <div className="evalws-fullscreen">
      <PropertyEvaluationWorkspace
        clientId={null}
        projectId="VP678"
        propertyId="P00007"
        floorId={null}
        title="Plot 14 — Ground Floor"
        floors={[
          { floorId: '0', label: 'Ground Floor' },
          { floorId: '1', label: 'First Floor' },
        ]}
        actor={{ uid: null, name: 'Preview' }}
        isAdmin={false}
        intakeTier="L1A_R1"
        linkedPropertyRefs={[]}
        onFloorChange={() => {}}
        onDone={() => {}}
      />
    </div>
  );
}
